import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Tabs, Row, Col, message } from 'antd';
import SaleInformation2 from './SaleInformation2';
import CallingTrack from './CallingTrack';
import EmailTrack from './EmailTrack';
import LinkedinTrack from './LinkedinTrack';
import SchedulingCall from './SchedulingCall';
import OperationsTeam from './OperationsTeam';
import SalesWorkHistory from './SalesWorkHistory';
import { setRefreshStatus, setSale, createLeadThunk } from '../../../Slices/salesSlice';
import { useLeadListKey } from './useLeadList';
import { setLoader } from '../../../Slices/loaderSlice';
import { setLastContactedDates } from '../../../Slices/lastContactedDatesSlice';
import { useErrorLogger } from "../../../utils";
import { normalizeTimeZone } from "../../../utils/timeZone";
import { AntdButton } from '../../../blueplanitUtils/InputField';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";
import { fetchEmployeesByRoute } from '../../../Slices/Employeeaccessslice.js';
const validationSchema = Yup.object({
    agencyName: Yup.string()
        .required('Agency Name is required'),
    leadsContacts: Yup.array().of(
        Yup.object({
            email: Yup.string()
                .trim()
                .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,}$/, "Invalid email format")
                .email('Invalid email format'),
            remarks: Yup.string(),  // No validation for remarks
        })
    ),
    leadsScheduledCalls: Yup.array().of(
        Yup.object().shape({
            emails: Yup.string()
                .trim()
                .email('Invalid email format')
                .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,}$/, "Invalid email format"),
        })
    ),
    leadsOPS: Yup.array().of(
        Yup.object().shape({
            emails: Yup.string()
                .trim()
                .email('Invalid email format') // Validate email format
                .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,}$/, "Invalid email format")
        })
    ),

});

const AddSales = (props) => {

    const { isCreate, handleClose } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // Route-filtered employees for Assign To dropdown (only employees with /sales route access)
    const routeFilteredEmployees = useSelector((state) => state.employeeAccess?.routeFilteredEmployees?.["/sales"] || []);
    const refreshStatus = useSelector((state) => state.sales.refreshStatus);
    const salesLeadId = useSelector((state) => state?.sales?.sale?.leadID);
    const salesDates = useSelector((state) => state?.sales?.sale);
    const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
    const [tabValue, setTabValue] = useState("0");
    const [showSidePanel, setShowSidePanel] = useState(false);
    const [newLead, setNewLead] = useState({});
    const [isDisabled, setIsDisabled] = useState(false);
    const createSource = useSelector((state) => state.sales.createSource);
    // The window's lead list this form was opened from (reset after a successful create).
    const { listKey } = useLeadListKey();

    useEffect(() => {
        dispatch(fetchEmployeesByRoute({ route: "/sales" }));
    }, [dispatch]);

    const { logError } = useErrorLogger();
    const assignToUsers = routeFilteredEmployees;

    const getLoginUser = () => {
        let username = ''
        let userObject = assignToUsers?.filter((key) => key?.id === loginUser.id);
        if (userObject.length > 0) {
            username = userObject[0]?.firstname + ' ' + userObject[0]?.lastname
        }
        return username;
    }

    const initialValues = {
        id: '',
        leadID: '',
        createdDate: '',
        createdBy: getLoginUser() || '',
        lastUpdatedDate: '',
        lastContactedDate: '',
        followup: '',
        followupDate: '',
        callscheduledwithOPs: '',
        assign: true,
        assignedTo: getLoginUser() || '',
        assignTo: '',
        isAssignLocked: false,
        assignLockedAt: null,
        assignUnlockAt: null,
        priority: 'Low',
        status: 'New',
        stage: 'Data team',
        channel: '',
        successfull: '',
        agencyName: '',
        dba: '',
        address: '',
        mailingAddress: '',
        city: '',
        state: '',
        timeZone: '',
        webURL: '',
        contactInfoURL: '',
        linkedinURL: '',
        contactInfoComments: '',
        callingComments: '',
        emailComments: '',
        linkedinComments: '',
        scheduledCallComments: '',
        opsTeamComments: '',
        leadsContacts: [],
        leadsCalls: [],
        leadsEmails: [],
        leadsLinkedins: [],
        leadsScheduledCalls: [],
        leadsOPS: [],
        isInPipeline: false,
        pipelineStage: '',
        lostReason: '',
        dealValue: '',
    };

    const items = [
        { label: 'Calling Track', key: '0' },
        { label: 'Email Track', key: '1' },
        { label: 'Linkedin Track', key: '2' },
        { label: 'Scheduling a Call', key: '3' },
        { label: 'Operations Team Communication', key: '4' },
        !isCreate && { label: 'Attachment History', key: '5' },
        !isCreate && { label: 'Work History', key: '6' },
    ].filter(Boolean);

    const tabChange = (key) => {
        setTabValue(key);
    };

    const cancelHandelar = () => {
        handleClose()
        dispatch(setLastContactedDates([]))
        if (refreshStatus === null) {
            dispatch(setRefreshStatus(true));
        }
        dispatch(setSale({}));
    }


    const startTimer = () => {
        setIsDisabled(true); // Disable the button
        setTimeout(() => {
            setIsDisabled(false); // Enable the button after 5 seconds
        }, 5000);
    };

    const requestSubmit = async (values, { resetForm }) => {

        const { createdDate, lastUpdatedDate, ...newObject } =
            newLead;
        const {
            createdDate: date,
            lastUpdatedDate: last,
            ...createdObject
        } = values;

        if (JSON.stringify(newObject) === JSON.stringify(createdObject)) {
            startTimer();
            message.error({
                content:
                    "You haven't changed anything compared to the last lead. Please modify a value before submitting.",
                duration: 3,
                className: "custom-toast-center",
            });
            return;
        }
        startTimer();
        setNewLead(values);

        try {

            dispatch(setLoader(true))// Show loader when starting the submission

            const valuesObject = {
                createdDate: Date.now() + "" || "",
                createdBy: getLoginUser() || "",
                lastUpdatedDate: Date.now() + "" || "",
                lastContactedDate: values?.lastContactedDate || "",
                followup: values?.followup || false,
                followupDate: values?.followupDate || "",
                callscheduledwithOPs: values?.callscheduledwithOPs || false,
                assign: values?.assign || false,
                assignedTo: values?.assignedTo || "",
                assignTo: values?.assignTo || "",
                isAssignLocked: values?.isAssignLocked || false,
                assignLockedAt: values?.isAssignLocked ? Date.now() + "" : null,
                assignUnlockAt: values?.isAssignLocked
                    ? Date.now() + (30 * 24 * 60 * 60 * 1000) + ""
                    : null,
                priority: values?.priority || "",
                status: values?.status || "",
                stage: values?.stage || "",
                channel: values?.channel || "",
                successfull: values?.successfull || false,
                agencyName: values.agencyName?.trim() || "",
                dba: values.dba?.trim() || "",
                address: values.address?.trim() || "",
                mailingAddress: values.mailingAddress?.trim() || "",
                city: values.city?.trim() || "",
                state: values.state?.trim() || "",
                timeZone: normalizeTimeZone(values?.timeZone) || "",
                webURL: values?.webURL || "",
                contactInfoURL: values?.contactInfoURL || "",
                linkedinURL: values?.linkedinURL || "",
                contactInfoComments: values?.contactInfoComments || "",
                callingComments: values?.callingComments || "",
                emailComments: values?.emailComments || "",
                linkedinComments: values?.linkedinComments || "",
                scheduledCallComments: values?.scheduledCallComments || "",
                opsTeamComments: values?.opsTeamComments || "",
                isInPipeline: values?.isInPipeline === true,
                pipelineStage: values?.pipelineStage || "",
                lostReason: values?.lostReason || "",
                dealValue: values?.dealValue || "",
                leadsContacts:
                    values?.leadsContacts?.map(({ __typename, ...rest }) => rest) || [],
                leadsCalls:
                    values?.leadsCalls?.map(({ __typename, ...rest }) => rest) || [],
                leadsEmails:
                    values?.leadsEmails?.map(({ __typename, ...rest }) => rest) || [],
                leadsLinkedins:
                    values?.leadsLinkedins?.map(({ __typename, ...rest }) => rest) || [],
                leadsScheduledCalls:
                    values?.leadsScheduledCalls?.map(({ __typename, ...rest }) => rest) ||
                    [],
                leadsOPS:
                    values?.leadsOPS?.map(({ __typename, ...rest }) => rest) || [],
            };

            const result = await dispatch(
                createLeadThunk({ valuesObject, listKey })
            ).unwrap();

            if (result?.id) {
                navigate(`/sales/${result.id}`);
            }

            resetForm();
        } catch (error) {
            dispatch(setLoader(false)); // Hide loader
            await logError("SalesInformationPopup", "requestSubmit", error.message);

            console.error('Error creating lead:', error);
            message.error({
                content: "Failed to create lead. Please try again.",
                duration: 5,
                className: "alert alert-danger text-center",
            });
        }
    };

    return (
        <>
            <div style={{ width: '100%' }}>
                <Formik
                    initialValues={initialValues}
                    validateOnChange={true}
                    onSubmit={requestSubmit}
                    validationSchema={validationSchema}
                >
                    {({ resetForm, handleBlur, handleChange, handleSubmit, isSubmitting, values, setFieldValue, errors, touched }) => (

                        <form noValidate onSubmit={handleSubmit}>

                            <Row gutter={16} className="action-row">
                                <Col
                                    span={24}
                                    className={`action-buttons ${showSidePanel ? "sidepanel-open" : "sidepanel-closed"}`}
                                >
                                    <AntdButton
                                        color="primary"
                                        variant="solid"
                                        htmlType="submit"
                                        disabled={isDisabled}
                                        className="small-create-btn"
                                        label={<FontAwesomeIcon icon={faPlus} />}
                                        size="small"
                                    />

                                    <AntdButton
                                        color="danger"
                                        variant="solid"
                                        size="small"
                                        onClick={cancelHandelar}
                                        className="small-create-btn"
                                        label={<FontAwesomeIcon icon={faXmark} />}
                                    />
                                </Col>

                                <div
                                    onClick={() => setShowSidePanel(!showSidePanel)}
                                    className={`sidepanel-toggle ${showSidePanel ? "open" : ""}`}
                                >
                                    <i className="fa-solid fa-bars"></i>
                                </div>
                            </Row>



                            <SaleInformation2
                                salesLeadId={salesLeadId}
                                salesDates={salesDates}
                                assignToUsers={assignToUsers}
                                handleChange={handleChange}
                                values={values}
                                setFieldValue={setFieldValue}
                                showSidePanel={showSidePanel}
                            />

                            <div className={`track-sidepanel ${showSidePanel ? "open" : ""}`}>
                                <div className="track-sidepanel-tabs">
                                    <Tabs
                                        activeKey={String(tabValue)}
                                        onChange={tabChange}
                                        tabPosition="top"
                                        items={[
                                            { key: "0", label: <i className="fa-solid fa-phone" /> },
                                            { key: "1", label: <i className="fa-solid fa-message" /> },
                                            { key: "2", label: <i className="fa-brands fa-linkedin" /> },
                                            { key: "3", label: <i className="fa-solid fa-calendar-check" /> },
                                            { key: "4", label: <i className="fa-solid fa-people-group" /> },
                                        ]}
                                    />
                                </div>
                                <div className="track-sidepanel-body">
                                    {tabValue === '0' && <CallingTrack handleChange={handleChange} values={values} assignToUsers={assignToUsers} setFieldValue={setFieldValue} />}
                                    {tabValue === '1' && <EmailTrack handleChange={handleChange} values={values} assignToUsers={assignToUsers} setFieldValue={setFieldValue} />}
                                    {tabValue === '2' && <LinkedinTrack handleChange={handleChange} values={values} assignToUsers={assignToUsers} setFieldValue={setFieldValue} />}
                                    {tabValue === '3' && <SchedulingCall handleChange={handleChange} values={values} assignToUsers={assignToUsers} setFieldValue={setFieldValue} />}
                                    {tabValue === '4' && <OperationsTeam handleChange={handleChange} values={values} assignToUsers={assignToUsers} setFieldValue={setFieldValue} />}
                                    {!isCreate && tabValue === '6' && <SalesWorkHistory handleChange={handleChange} values={values} assignToUsers={assignToUsers} />}
                                </div>
                            </div>
                        </form>
                    )}
                </Formik>
            </div>
        </>
    );

}

export default AddSales;